import type {
	AiCostAmountPayload,
	AiCostAudioPayload,
	AiCostDocumentsPayload,
	AiCostQuantitiesPayload,
} from '@Application/AiCosts/Actions/aiCostSummaryFetched';
import type { AiCostDimension } from '@Application/AiCosts/AiCostDimension';

type AiCostReferencePayload = { readonly id: number; readonly label: string | null };

export type AiCostBreakdownRowPayload = {
	readonly subject: {
		readonly id: number | null;
		readonly label: string | null;
		readonly date: string | null;
		readonly isDeleted: boolean;
	};
	readonly interviewKind: { readonly value: 'conversation' | 'notes'; readonly label: string } | null;
	readonly usage: { readonly value: string; readonly label: string } | null;
	readonly organization: AiCostReferencePayload | null;
	readonly facility: AiCostReferencePayload | null;
	readonly facilityCount: number | null;
	readonly user: AiCostReferencePayload | null;
	readonly processedAt: string | null;
	readonly audio: AiCostAudioPayload;
	readonly documents: AiCostDocumentsPayload;
	readonly cost: AiCostAmountPayload;
	readonly callCount: number | null;
	readonly quantities: AiCostQuantitiesPayload | null;
};

export type AiCostBreakdownFetchedPayload = {
	readonly totalRecords: number;
	readonly results: readonly AiCostBreakdownRowPayload[];
};

export type AiCostBreakdownFetchedAction = {
	type: 'AI_COST_BREAKDOWN_FETCHED';
	payload: AiCostBreakdownFetchedPayload;
	dimension: AiCostDimension;
	accountId: number;
	queryKey: string;
	page: number;
};

export default (
	payload: AiCostBreakdownFetchedPayload,
	dimension: AiCostDimension,
	accountId: number,
	queryKey: string,
	page: number,
): AiCostBreakdownFetchedAction => ({
	type: 'AI_COST_BREAKDOWN_FETCHED',
	payload,
	dimension,
	accountId,
	queryKey,
	page,
});
